// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__2nLU-","qmeta":"Video_qmeta__2Ao6i"};